import NotAvailable from '../../components/fallback/NotAvailable'

const Notifications: React.FC = () => {
  return <NotAvailable title={'Notifications'} />
}

export default Notifications
